let { jQuery: $ } = window;
import CMP from "./CMP.class";

export default class CookiebotCMP extends CMP {

    constructor($body, readyCB = ()=>true) {
        super($body, readyCB);

        if(typeof $ === 'undefined') $ = window.jQuery;

        window.addEventListener("CookiebotOnAccept", () => this.#changeConsent());
        window.addEventListener("CookiebotOnDecline", () => this.#changeConsent());
    }

    load() {
        console.log("Loading Cookiebot Integration.");

        for(let i in this.types) {
            const type = this.types[i];

            if(this.hasConsent(type)) {
                $(window).trigger(this.events.consent[type]);
            } else {
                $(window).trigger(this.events.denied[type]);
            }
        }
    }

    hasConsent(category) {
        return window.Cookiebot.consent[category];
    }

    open() {
        window.Cookiebot.show();
    }

    #changeConsent() {
        for(let i in this.types) {
            const type = this.types[i];

            if(this.hasConsent(type)) {
                $(window).trigger(this.events.consent[type]);
            } else {
                $(window).trigger(this.events.denied[type]);
            }
        }
    }


    get consentTypes() {
        return ["preferences", "marketing", "statistics"];
    }
}